import type { CSSProperties } from "react";
import { backgroundColors, cssClass } from "./constant";

export type AnswerImageStylesType = {
  outerDiv: CSSProperties;
  questionContainer: CSSProperties;
  imageContainer: CSSProperties;
  microphoneContainer: CSSProperties;
  answerContainer: CSSProperties;
};

export const answerImageStyles: AnswerImageStylesType = {
  outerDiv: {
    ...cssClass.outerDiv,
    ...cssClass.fontFamily,
    ...cssClass.mediumFont,
    gap: "10px",
  },
  questionContainer: {
    textAlign: "center",
    backgroundColor: backgroundColors.white,
    padding: "15px",
    borderRadius: "14px",
  },
  imageContainer: {
    borderRadius: "14px",
    aspectRatio: "4/3",
    flexShrink: 0,
    width: "80%",
    overflow: "hidden",
    margin: "auto",
    ...cssClass.centerFlex,
    backgroundColor: backgroundColors.white,
    color: backgroundColors.gray,
  },
  microphoneContainer: {
    borderRadius: "14px",
    width: "20%",
    aspectRatio: "1/1",
    backgroundColor: backgroundColors.white,
    margin: "0 auto",
    color: backgroundColors.orange,
    ...cssClass.centerFlex,
    ...cssClass.button,
  },
  answerContainer: {
    textAlign: "center",
    backgroundColor: backgroundColors.white,
    padding: "10px",
    borderRadius: "14px",
  },
};
